export default __webpack_public_path__ + "static/media/Camion6.d6fa98f4.png";